var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "url(#pattern0_401_232)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_401_232",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_401_232",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_401_232",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACtElEQVR4nO3dPWtUQRyF8QFFfKlUbAR70UYQFbRUtFJs0vhSiX4ErQS1FsE+Vnb5EhG0sgph2fk/s0UgELBQbBIVoly54AeImuycufcceLo0Oz8GEgg7KXme53me53me5w1oGxsbhyPiNvACeAMszavZbHaq9ueXWSnlRES8jogtoKvRbDY7W/scJJZzvhERX2tBsEOQyWRyIA19EXE/In7WxmAHIBHxOCKupqEuIq5ExI/aEOwQBHgWEd8GibK8vLwfyLUR+EuQ/ud6FOBaGtKAR7UB+EeQPyhbg7opwIeWQRjSTZlOp8cj4lfrIAzlpgAXax8+uwQyiJuSc741JBBavykRsTA0EFq+KUMFoVWUIYPQIsrQQWgNZQwgtIQyFhBaQRkTCC2gjA0EdZQxgqCMMlYQVFFaBck5n8w5n//fSilnktJaBRnsDCI2g4hNFQQ4l8Y4VZCc8900xqmCAB/7/4ZJY5swSAe8XVlZOZLGNHGQLiI+AYsR8TQinuxxp2t7yIMwX/yF2h4GwSCdagZBK4OglUHQyiBoZRC0MghaGQStDIJWBkErg6CVQdDKIGhlELQyCFoZBK0MglYGQSuDoJVB0MogaGUQtDIIWhkErQyCVgZBK4OglUHQyiBoZRC0MghaGQStDIJWBkErg6CVQdDKIGhlELQyCFoZBK0MglYSIKrPVVChUspNhRtyofZBIFL/pZgqTx5JvF1IxfozWF1dPZoUBryvfSDUB3mXVAY8rH0g1Ad5kFTWdd2+iJjWPhTqleW+TjDnfFnp6VXmdzO+A5eS4iLiHrBd+5CYX9ullDtJeaWU68AXgcPq9rjPzTyt1/8qDLwCNgUOrtvlNiPi5WQyOZZa2/r6+qH+r1fgef/NoMBSoy32z1v0n2Vtbe1g7XP1PM/zPM/zPM9Lu7jfck97wQRSYT0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.ea3b057321c20f69b57655042415fcd5.svg";
export { ForwardRef as ReactComponent };